import { IRuleType } from '../entities/ruleEngine/Common';
import { IRule } from '../entities/ruleEngine/legacy/IRule';

const isLegacyRule = (rule: IRuleType): rule is IRule => {
	return (rule as IRule).statements !== undefined;
};

export { isLegacyRule };
